// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1___dc7b40d661745b0dfdf","cls2":"PaperSelector-cls2__cfbb30a85b21ed0f71e4 PaperSelector-cls1___dc7b40d661745b0dfdf"};